import React, { useState } from 'react';
import { Modal, Box, Typography, Button, Divider, Grid, TextField, InputAdornment } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export default function ModalModificar({ open, handleClose, formData, fecha, hora, refVisita, onConfirm }) {

  const [loading, setLoading] = useState(false);

  const modificarVisita = async () => {
  const fechaStr = fecha instanceof Date 
  ? fecha.toLocaleDateString('en-CA') 
  : (() => {
      const [day, month, year] = fecha.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    })();
  const horaStr = hora.length === 5 ? `${hora}:00` : hora;

  console.log('Enviando a modificarVisita:', { ref: refVisita, fecha: fechaStr, hora: horaStr }); // <- añade esto

  const response = await fetch('/api/modificarVisita', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ref: refVisita, fecha: fechaStr, hora: horaStr }),
  });

  const data = await response.json();
  console.log('Respuesta modificarVisita:', data); // <- añade esto
  if (!response.ok) throw new Error(data.error);
  return data.peticion;
};

  const enviarCorreo = async (peticion) => {
    try {
      await fetch('/api/conexionmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: formData.email,
          subject: 'Tu visita ha sido reprogramada - Cámara de Madrid',
          html: `
            <html>
            <body style="margin:0; padding:0; background-color:#f4f4f4; font-family: Arial, sans-serif;">
              <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px 0;">
                <tr>
                  <td align="center">
                    <table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px; background-color:#ffffff; border-radius:8px; overflow:hidden;">
                      <tr>
                        <td style="background-color:#f2f2f2; padding:20px; text-align:center;">
                          <img src="https://cursos-formacion.camaramadrid.es/wp-content/themes/cursos-cm/assets/fpyempleo.png"
                               alt="Cámara de Madrid" style="max-width:180px; height:auto;">
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:30px; text-align:center; color:#333333;">
                          <h2 style="margin-top:0; margin-bottom:20px; color:#000000;">Visita reprogramada</h2>
                          <p style="font-size:16px; margin:10px 0;">
                            Hola <strong>${formData.nombre} ${formData.apellidos}</strong>,
                          </p>
                          <p style="font-size:15px; line-height:1.6; margin:10px 0;">
                            Hemos recibido tu solicitud para reprogramar tu visita a la Escuela de FP.
                          </p>
                          <table style="margin:10px auto; border-collapse:collapse; text-align:left; font-size:14px;">
                            <tr>
                              <td style="padding:3px 7px; font-weight:bold;">📅 Nueva fecha:</td>
                              <td style="padding:3px 7px;">${fecha}</td>
                            </tr>
                            <tr>
                              <td style="padding:3px 7px; font-weight:bold;">🕒 Nueva hora:</td>
                              <td style="padding:3px 7px;">${hora}</td>
                            </tr>
                          </table>
                          <p style="font-size:15px; line-height:1.6; margin:10px 0;">
                            En breve revisaremos la disponibilidad y te confirmaremos si la fecha solicitada es posible.
                          </p>
                          <p style="margin-top:20px;">Gracias por tu interés.</p>
                          <p style="margin-top:20px;">
                            Un saludo,<br><br>
                            <strong>Cámara Oficial de Comercio de Madrid</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background: linear-gradient(to right, #f86254, #b10000); color:#ffffff; padding:15px;">
                          <table width="100%" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="font-size:13px; text-align:left;">www.camaramadrid.es</td>
                              <td style="font-size:13px; text-align:center;">915 38 35 00</td>
                            </tr>
                            <tr>
                              <td style="font-size:13px; text-align:left; padding-top:8px;">Pedro Salinas 11, Madrid</td>
                              <td style="font-size:13px; text-align:center; padding-top:8px;">camara@camaramadrid.es</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            </html>
          `
        }),
      });
    } catch (error) {
      console.error('Error enviando correo:', error);
    }
  };

  const enviarCorreoAdmin = async (peticion) => {
    const fechaFormateada = new Date(peticion.fecha).toLocaleDateString('es-ES');
  const horaFormateada = peticion.hora.slice(0, 5);
    try {
      await fetch('/api/conexionmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: 'visitascampus@camaramadrid.es', 
          subject: 'Un visitante ha reprogramado su visita',
          html: `
            <html>
            <body style="margin:0; padding:0; background-color:#f4f4f4; font-family: Arial, sans-serif;">
              <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px 0;">
                <tr>
                  <td align="center">
                    <table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px; background-color:#ffffff; border-radius:8px; overflow:hidden;">
                      <tr>
                        <td style="background-color:#f2f2f2; padding:20px; text-align:center;">
                          <img src="https://cursos-formacion.camaramadrid.es/wp-content/themes/cursos-cm/assets/fpyempleo.png"
                               alt="Cámara de Madrid" style="max-width:180px; height:auto;">
                        </td>
                      </tr>
                      <tr>
                        <td style="padding:30px; text-align:center; color:#333333;">
                          <h2 style="margin-top:0; margin-bottom:20px; color:#000000;">Visita reprogramada</h2>
                          <p style="font-size:15px; line-height:1.6; margin:10px 0;">
                            Un visitante ha reprogramado su visita.
                          </p>
                          <table style="margin:10px auto; border-collapse:collapse; text-align:left; font-size:14px;">
                            <tr>
                              <td style="padding:3px 7px; font-weight:bold;">👤 Visitante:</td>
                              <td style="padding:3px 7px;">${peticion.nombre} ${peticion.apellidos}</td>
                            </tr>
                            <tr>
                              <td style="padding:3px 7px; font-weight:bold;">📅 Nueva fecha:</td>
                              <td style="padding:3px 7px;">${peticion.fecha}</td>
                            </tr>
                            <tr>
                              <td style="padding:3px 7px; font-weight:bold;">🕒 Nueva hora:</td>
                              <td style="padding:3px 7px;">${peticion.hora}</td>
                            </tr>
                          </table>
                          <p style="margin-top:20px;">
                            Un saludo,<br><br>
                            <strong>Cámara Oficial de Comercio de Madrid</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background: linear-gradient(to right, #f86254, #b10000); color:#ffffff; padding:15px;">
                          <table width="100%" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="font-size:13px; text-align:left;">www.camaramadrid.es</td>
                              <td style="font-size:13px; text-align:center;">915 38 35 00</td>
                            </tr>
                            <tr>
                              <td style="font-size:13px; text-align:left; padding-top:8px;">Pedro Salinas 11, Madrid</td>
                              <td style="font-size:13px; text-align:center; padding-top:8px;">camara@camaramadrid.es</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            </html>
          `
        }),
      });
    } catch (error) {
      console.error('Error enviando correo al admin:', error);
    }
  };

  const handleConfirmar = async () => {
    setLoading(true);
    try {
      const peticion = await modificarVisita();
      await enviarCorreo(peticion);
      await enviarCorreoAdmin(peticion);
      if (onConfirm) onConfirm();
    } catch (error) {
      console.error('Error modificando visita:', error);
      alert('No se pudo modificar la visita. Inténtelo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 700,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 0,
        }}
      >
        <Box
          sx={{
            p: 2,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            background: 'linear-gradient(to right, #ff4635, #940000)',
            color: 'white',
            textAlign: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <EventNoteIcon />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Modificación de cita
            </Typography>
          </Box>
        </Box>

        <Box sx={{ p: 4 }}>
          <TextField
            label="Nombre"
            value={formData.nombre}
            fullWidth
            InputProps={{
              readOnly: true,
              style: { fontWeight: 'bold' },
              startAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment>,
            }}
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <TextField
            label="Apellidos"
            value={formData.apellidos}
            fullWidth
            InputProps={{
              readOnly: true,
              style: { fontWeight: 'bold' },
              startAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment>,
            }}
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <TextField
            label="Email"
            value={formData.email}
            fullWidth
            InputProps={{
              readOnly: true,
              style: { fontWeight: 'bold' },
              startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment>,
            }}
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <TextField
            label="Teléfono"
            value={formData.telefono}
            fullWidth
            InputProps={{
              readOnly: true,
              style: { fontWeight: 'bold' },
              startAdornment: <InputAdornment position="start"><PhoneIcon /></InputAdornment>,
            }}
            variant="outlined"
            sx={{ mb: 3 }}
          />

          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={4} sx={{ mb: 3 }}>
            <Grid item xs={6}>
              <TextField
                label="Nueva fecha"
                value={fecha}
                fullWidth
                InputProps={{
                  readOnly: true,
                  style: { fontWeight: 'bold' },
                  startAdornment: <InputAdornment position="start"><EventIcon /></InputAdornment>,
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Nueva hora"
                value={hora}
                fullWidth
                InputProps={{
                  readOnly: true,
                  style: { fontWeight: 'bold' },
                  startAdornment: <InputAdornment position="start"><AccessTimeIcon /></InputAdornment>,
                }}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Divider sx={{ mb: 3 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
            <Button variant="outlined" color="error" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirmar} disabled={loading}>
              {loading ? 'Modificando...' : 'Confirmar cambio'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}